import React, { useEffect, useRef, useState } from "react";
import { Briefcase, Search } from "react-feather";
import LoadingSpinner from "../../components/LoadingSpinner";
import SearchDropdown from "../../components/input/SearchDropdown";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import { statusByContext } from "../../api/statusApi";
import { FORMS, MODULES, STATUS_GROUPS } from "../../const";
import Button from "../../components/input/Button";
import Grid from "../../components/Grid";
import { useSelector } from "react-redux";
import { searchCharge } from "../../api/finance/addChargesApi";
import {
  ChargeCellStyle,
  chargeCreationStatusLabelStyle,
  EVInvCellStyle,
  ResizableScrollingTextRenderer,
} from "../../components/renderer/StyleRenderer";
import Modal from "../../components/Modal";
import ChargeStatusChange from "../../components/support/financeAmendment/ChargeStatusChange";
import { toast } from "react-toastify";

const FinanceAmendment = () => {
  const [tab, setTab] = useState(1);

  const [accordion, setAccordion] = useState(true);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [job, setJob] = useState("");
  const [request, setRequest] = useState("");
  const [transporter, setTransporter] = useState("");
  const [customer, setCustomer] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [jobStatus, setJobStatus] = useState([]);
  const [evNumber, setEvNumber] = useState("");
  const [invNumber, setInvNumber] = useState("");
  const [dateType, setDateType] = useState("");
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [dateTypeOpt, setDateTypeOpt] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const gridRef = useRef();
  const [currentSearch, setCurrentSearch] = useState({});
  const [searchResult, setSearchResult] = useState([]);
  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedRowsSet, setSelectedRowsSet] = useState([]);
  const [allJobStatus, setAllJobStatus] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [isAdditional, setIsAdditional] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const modelRef = useRef(null);
  const auth = useSelector((state) => state.user.permissions[MODULES.Finance]);

  const [isStatusLoading, setIsStatusLoading] = useState(false);

  const chargeRemoval = auth[FORMS.FINANCE_AMENDMENT.CHARGE_REMOVAL.form];
  const chargeRemovalPermission = chargeRemoval?.FIELD?.VIEW;


  const user = useSelector((state) => state.user);

  useEffect(() => {
    (async () => {
      const { date_types: dateTypeData } = await getBulkDropdownData([
        { key: "date_types" },
      ]);
      const jobStatus = await statusByContext(STATUS_GROUPS.JOB_CHARGE);
      setJobStatusOptions(jobStatus);
      setDateTypeOpt(dateTypeData);
    })();
  }, []);

  useEffect(() => {
    if (jobStatusOptions?.length > 0) {
      let jobStatusValues = [];
      jobStatusOptions.forEach((option) => {
        jobStatusValues.push(option.value);
      });
      setAllJobStatus(jobStatusValues);
    }
  }, [jobStatusOptions]);

  const getJobCodes = (event) => {
    const regex = /^[JOB0-9\-,]*$/;
    const currentValue = event.target.value.toUpperCase();
    if (regex.test(currentValue)) {
      setJob(currentValue);
    } else {
      setJob("");
    }
  };

  const getRequestCodes = (event) => {
    const currentValue = event.target.value.toUpperCase();
    setRequest(currentValue);
  };

  const statusChange = () => {
    if (selectedRowsSet.length === 0) {
      toast.error("Please select at least one charge header", {
        autoClose: 2000,
      });
      return;
    }

    setIsModalOpen(true);
    modalRef.current?.showModal();
  };

  const getActionMenuOptions = () => {
    const actionMenu = [];
    if (chargeRemovalPermission) {
      actionMenu.push({
        key: 1,
        text: "Remove Charges",
        value: 1,
      });
    }

    return actionMenu;
  };

  const actionMenuHandler = (data) => {
    switch (data.value) {
      case 1:
        statusChange();
        break;
      default:
        break;
    }
  };
  const handleSectionChanged = (action) => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRowsSet(selectedData);
    if (selectedData.length > 0) {
      setSelectedJobIds(selectedData?.map((item) => item.chgId));
     
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setSearchSubmitLoading(true);
    setSelectedRowsSet([]);
    setSelectedJobIds([]);
    setCurrentSearch({
      dateType: dateType ? dateType : null,
      fromDate: fromDate ? fromDate : null,
      toDate: toDate ? toDate : null,
      transporter: transporter ? transporter.toString() : null,
      vehicle: vehicle ? vehicle.toString() : null,
      customer: customer ? customer.toString() : "",
      status:
        jobStatus && jobStatus.length > 0
          ? jobStatus.join(",")
          : allJobStatus.join(","),
      jobCode: job ? job : "",
      requestCode: request ? request : "",
      evNumber: evNumber ? evNumber.toString() : "",
      invNumber: invNumber ? invNumber.toString() : "",
    });
    setSearchClicked(true);

    const response = await searchCharge({
      dateType: dateType ? dateType : null,
      fromDate: fromDate ? fromDate : null,
      toDate: toDate ? toDate : null,
      transporter: transporter ? transporter.toString() : null,
      vehicle: vehicle ? vehicle.toString() : null,
      customer: customer ? customer.toString() : "",
      status:
        jobStatus && jobStatus.length > 0
          ? jobStatus.join(",")
          : allJobStatus.join(","),
      jobCode: job ? job : "",
      requestCode: request ? request : "",
      evNumber: evNumber ? evNumber.toString() : "",
      invNumber: invNumber ? invNumber.toString() : "",
    });

    const mappedRes = response?.map((item) => ({
      ...item,
      distance: item.distance ? item.distance : "N/A",
      evStatus: item.evStatus === null ? 1 : item.evStatus,
      invStatus: item.invStatus === null ? 1 : item.invStatus,
      chg_code: item.chg_code !== null ? item.chg_code : "N/A",
    }));
    setSearchResult(mappedRes);
    setSearchSubmitLoading(false);
  };
  const handleReset = (e) => {
    e.preventDefault();
    setSearchFieldReset(true);
    setDateType("");
    setFromDate("");
    setToDate("");
    setJob("");
    setRequest("");
    setTransporter("");
    setCustomer("");
    setVehicle("");
    setJobStatus([]);
    setEvNumber("");
    setInvNumber("");
    setSearchClicked(false);
    setSearchResult([]);
    setSelectedRow({});
    setEditMode(false);
    setIsLoading(false);
    setIsAdditional(false);
  };
  const modalRef = useRef();
  const openModal = () => {
    modalRef.current?.showModal();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    modalRef.current?.close();

    handleSearch({ preventDefault: () => {} });
  };

  return (
    <div>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu top attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Briefcase size={15} style={{ marginRight: "5px" }} />
            </span>
            Charge Search
          </div>
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${accordion ? "active" : ""}`}
            onClick={() => {
              setAccordion(!accordion);
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div className={`content ${accordion ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="three fields">
                  <Dropdown
                    label="Date Type"
                    placeholder="Date Type"
                    style={{ height: "20px" }}
                    options={dateTypeOpt}
                    value={dateType}
                    onChange={(e, data) => {
                      setDateType(data.value);
                    }}
                    clearable={false}
                  />
                  <Input
                    type="date"
                    label="To Date"
                    placeholder="To Date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <Input
                    type="date"
                    label="To Date"
                    placeholder="To Date"
                    min={fromDate}
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                  />
                </div>
                <div className="four fields">
                  <SearchDropdown
                    key={1}
                    clearable={true}
                    onClear={() => setTransporter("")}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setTransporter(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />
                  <SearchDropdown
                    key={1}
                    label={"Billing Customer"}
                    clearable={true}
                    onClear={() => setCustomer("")}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setCustomer(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Billing Customer",
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_stakeholder",
                      primaryKey: "stk_id",
                      fieldName: "stk_name",
                      id: customer,
                    }}
                  />
                  <SearchDropdown
                    key={1}
                    label={"Vehicle"}
                    clearable={true}
                    onClear={() => setVehicle("")}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setVehicle(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "vehicle",
                      value: "",
                    }}
                  />
                  <Dropdown
                    clearable
                    search={true}
                    options={jobStatusOptions}
                    placeholder="Job Status"
                    label="Job Status"
                    value={jobStatus}
                    onChange={(e, data) => {
                      setJobStatus(data.value);
                    }}
                    multiple={true}
                  />
                </div>
                <div className="four fields">
                  <Input
                    type="text"
                    label="Job"
                    placeholder="JOB-1234, JOB-1235, ..."
                    value={job}
                    onChange={getJobCodes}
                  />
                  <Input
                    type="text"
                    label="Request"
                    placeholder="REQ-1234, REQ-1235, ..."
                    value={request}
                    onChange={getRequestCodes}
                  />
                  <Input
                    type="text"
                    label="EV Number"
                    placeholder="EV Number"
                    value={evNumber}
                    onChange={(e) => setEvNumber(e.target.value)}
                  />
                  <Input
                    type="text"
                    label="INV Number"
                    placeholder="INV Number"
                    value={invNumber}
                    onChange={(e) => {
                      setInvNumber(e.target.value);
                    }}
                  />
                </div>
                <div
                  style={{
                    width: " 100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={handleSearch} />
                    <Button template="searchReset" onClick={handleReset} />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <div>
            {" "}
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                ref={gridRef}
                heading="Charges"
                autoHeight={false}
                multiRowSelection={true}
                content={searchResult}
                onSelectionChanged={handleSectionChanged}
                rowSelection="multiple"
                handleActionMenuChange={actionMenuHandler}
                showActionMenu={selectedRowsSet.length > 0 && chargeRemovalPermission}
                actionMenuOptions={getActionMenuOptions()}
                config={[
                  {
                    headerName: "Job",
                    field: "jobCode",
                    headerCheckboxSelection: true,
                    checkboxSelection: true,
                  },
                  {
                    headerName: "Request",
                    field: "requestCode",
                  },
                  {
                    headerName: "Charge Code",
                    field: "chg_code",
                  },

                  {
                    headerName: "Customer",
                    field: "customer",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Ev Status",
                    field: "costApproval",
                    cellRenderer: EVInvCellStyle,
                  },
                  {
                    headerName: "INV Status",
                    field: "revApproval",
                    cellRenderer: EVInvCellStyle,
                  },
                  {
                    headerName: "Vehicle",
                    field: "vehicle",
                  },
                  {
                    headerName: "Containers",
                    field: "connumbers",
                  },
                  {
                    headerName: "Transporter",
                    field: "transporter",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "jobStatus",
                    cellRenderer: chargeCreationStatusLabelStyle,
                    cellStyle: (params) => ({
                      backgroundColor: params.data.stacolor || "white",
                    }),
                  },
                  {
                    headerName: "Charge Status",
                    field: "chargeFlag",
                    cellRenderer: ChargeCellStyle,
                  },
                ]}
              />
            )}{" "}
          </div>
        )}
      </div>
      <Modal
        ref={modalRef}
        open={isModalOpen}
        onClose={closeModal}
        minWidth={"60vw"}
        style={{ height: "50vh" }}
        onCloseCleanUp={closeModal}
      >
        <ChargeStatusChange
          closeModal={closeModal}
          selectedRows={selectedRowsSet}
          isOpen={isModalOpen}
        />
      </Modal>
    </div>
  );
};

export default FinanceAmendment;
